<template>
    <div class="center-set col">
        <div class="card card-box mb-3 ninja-shadow col-5 ">
            <div class="card-body" id="print">
                <b-row class="text-center mb-5 mt-5">
                    <b-col>
                        <img v-if="klinik.foto_klinik == null" class="img-logo" src="/img/new_logo.png" alt="image body" />
                        <img v-else :src="klinik.foto_klinik" class="img-logo" alt="image body" />
                        <br />
                        {{ klinik.nama_klinik ? labelStartCase(klinik.nama_klinik) : '-' }} <br>
                        <template v-if="this.isDpm">
                            No. SIP {{ klinik.nomor_ijin || '-' }} <br>
                        </template>
                        <template v-else>
                            No. Izin {{ klinik.nomor_ijin || '-' }} <br>
                        </template>
                    </b-col>
                </b-row>
                <div class="d-flex flex-column">
                    <b-row class="mt-3 mb-1">
                        <b-col cols="12">
                            <b-row class="mb-1">
                                <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">No. Invoice</b-col>
                                <b-col cols="1" class="pl-0">:</b-col>
                                <b-col cols="6" class="pl-0">{{ dataStruk.no_invoice || '-' }}</b-col>
                            </b-row>
                            <b-row class="mb-1">
                                <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">Tanggal Transaksi</b-col>
                                <b-col cols="1" class="pl-0">:</b-col>
                                <b-col cols="6" class="pl-0">{{ !dataStruk.admission_time ? '-' : dataStruk.admission_time |
                                    formatDate }}</b-col>
                            </b-row>
                            <b-row class="mb-1">
                                <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">Jam Transaksi</b-col>
                                <b-col cols="1" class="pl-0">:</b-col>
                                <b-col cols="6" class="pl-0">{{ !dataStruk.admission_time ? '-' : dataStruk.admission_time |
                                    formatTime }} WIB</b-col>
                            </b-row>
                            <b-row class="mb-1">
                                    <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">Kasir</b-col>
                                    <b-col cols="1" class="pl-0">:</b-col>
                                    <b-col cols="6" class="pl-0">{{ !dataStruk.kasir ? '-' : dataStruk.kasir  }}</b-col>
                                </b-row>
                            <b-row class="mb-1">
                                <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">Metode Pembayaran</b-col>
                                <b-col cols="1" class="pl-0">:</b-col>
                                <b-col cols="6" class="pl-0" v-if="dataStruk.status == 'LUNAS'">{{
                                    labelMetodePembayaran(dataStruk) }}</b-col>
                                <b-col cols="6" class="pl-0" v-else> -</b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <hr class="bordering" />
                    <b-row class="f12 mb-2">
                        <b-col cols="12" class="font-weight-bold">Obat/BHP</b-col>
                    </b-row>
                    <b-row class="f12">
                        <b-col cols="1" class="pr-0 w1">No</b-col>
                        <b-col cols="5" class="pr-0 w5">Qty x Harga Layanan</b-col>
                        <b-col cols="6" class="text-right pl-0 w6">Sub Total (Rp)</b-col>
                    </b-row>
                    <hr class="bordering" />
                    <div v-if="details != null">
                        <div class="category-bpjs" v-if="tindakanBpjs.length > 0 || obatBpjs.length > 0">
                            <h6 class="font-weight-bold mb-4 color-gray-text">Ditanggung BPJS</h6>
                            <hr class="bordering" />
                            <div v-for="(item, index) in tindakanBpjs" :key="item.id">
                                <b-row class="f12">
                                    <b-col cols="1" class="font-weight-bold pr-0 w1">{{ index + 1 }}.</b-col>
                                    <b-col cols="10" class="font-weight-bold">{{ item.kode_layanan }} - {{ item.nama_layanan
                                    }}
                                    </b-col>
                                </b-row>
                                <b-row class="f12">
                                    <b-col cols="1" class="font-weight-bold pr-0"></b-col>
                                    <b-col cols="10">{{ item.quantity }} x Rp0,-</b-col>
                                </b-row>
                                <b-row class="f12">
                                    <b-col cols="1" class="font-weight-bold pr-0"></b-col>
                                    <b-col cols="5">
                                    </b-col>
                                    <b-col cols="6" class="text-right send-top">Rp0,-</b-col>
                                </b-row>
                            </div>
                            <div v-for="(item, index) in obatBpjs" :key="item.id">
                                <b-row class="f12">
                                    <b-col cols="1" class="font-weight-bold pr-0 w1">{{ tindakanBpjs.length + index + 1
                                    }}.</b-col>
                                    <b-col cols="10" class="font-weight-bold">{{ item.kode_layanan }} - {{ item.nama_layanan
                                    }}
                                    </b-col>
                                </b-row>
                                <b-row class="f12">
                                    <b-col cols="1" class="font-weight-bold pr-0"></b-col>
                                    <b-col cols="10">{{ item.quantity }} x Rp0,-</b-col>
                                </b-row>
                                <b-row class="f12">
                                    <b-col cols="1" class="font-weight-bold pr-0"></b-col>
                                    <b-col cols="5">
                                    </b-col>
                                    <b-col cols="6" class="text-right send-top">Rp0,-</b-col>
                                </b-row>
                            </div>
                        </div>
                        <div class="category-mandiri">
                            <!-- <h6 class="font-weight-bold mb-4 color-gray-text">Tidak Ditanggung BPJS</h6>
                            <hr class="bordering" /> -->
                            <div v-for="(item, index) in layananNormal" :key="item.id">
                                <b-row class="f12">
                                    <b-col cols="1" class="font-weight-bold pr-0 w1">{{ tindakanBpjs.length +
                                        obatBpjs.length + index + 1 }}.</b-col>
                                    <b-col cols="10" class="font-weight-bold">{{ item.kode_layanan }} - {{ item.nama_layanan
                                    }}
                                    </b-col>
                                </b-row>
                                <b-row class="f12">
                                    <b-col cols="1" class="font-weight-bold pr-0"></b-col>
                                    <b-col cols="10">{{ item.quantity }} x Rp{{
                                        parseFloat(item.tarif).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
                                    }},-
                                    </b-col>
                                </b-row>
                                <b-row class="f12">
                                    <b-col cols="1" class="font-weight-bold pr-0"></b-col>
                                    <b-col cols="5">
                                        <span v-if="item.jenis_potongan == 'RUPIAH'">Diskon Rp{{
                                            parseFloat(item.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
                                        }},-</span>
                                        <span v-if="item.jenis_potongan == 'PERSENTASE'">Diskon {{
                                            parseFloat(item.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
                                        }}%</span>
                                    </b-col>
                                    <b-col cols="6" class="text-right send-top">Rp{{
                                        parseFloat(item.subtotal_tarif_net).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                            "$1.")
                                    }},-</b-col>
                                </b-row>
                            </div>
                            <div v-if="layananNormal.length == 0">
                                <b-row>
                                    <b-col class="font-weight-bold">
                                        <h4>-</h4>
                                    </b-col>
                                </b-row>
                            </div>
                            <div v-else>
                                <hr class="bordering mt-5" />
                            </div>
                        </div>
                    </div>
                    <div v-if="dataStruk != null">
                        <b-row class="f12 mb-3">
                            <b-col cols="6" class="pr-0 p-col-6">TOTAL</b-col>
                            <b-col cols="6" class="text-right p-col-6">{{ calculateTotal(dataStruk)
                            }}</b-col>
                        </b-row>
                        <b-row class="f12 mb-3">
                            <b-col cols="6" class="pr-0 p-col-6">DISKON</b-col>
                            <b-col cols="6" class="text-right p-col-6">
                                <span v-if="dataStruk.jenis_potongan == 'RUPIAH'">Rp{{
                                    parseFloat(dataStruk.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
                                }},-</span>
                                <span v-else-if="dataStruk.jenis_potongan == 'PERSENTASE'">{{
                                    parseFloat(dataStruk.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
                                }}%</span>
                                <span v-else>Rp0,-</span>
                            </b-col>
                        </b-row>
                        <b-row class="f12 mb-5">
                            <b-col cols="6" class="font-weight-bold pr-0 p-col-6">TOTAL NETT</b-col>
                            <b-col cols="6" class="text-right p-col-6">{{
                                `Rp${parseFloat(dataStruk.total_net).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1.")},-`
                            }}</b-col>
                        </b-row>
                    </div>
                    <b-row class="f12 mb-5">
                        <b-col cols="7" offset="5" class="text-right">{{ tanggalCetak }}</b-col>
                    </b-row>
                    <b-row class="f12 mb-5">
                        <b-col cols="5" offset="7" class="text-center">{{ labelStartCase(dataStruk.kasir) }}</b-col>
                    </b-row>
                    <b-row class="f12 mt-3">
                        <b-col cols="12">
                            Created by : {{ labelStartCase(dataStruk.kasir) }} <br />
                            Created time : {{ dataStruk.created_time }} <br />
                            Admission time : {{ dataStruk.admission_time }} <br />
                        </b-col>
                    </b-row>
                    <b-row class="f12 mt-3">
                        <b-col cols="12" class="text-center">
                            <small class="font-weight-bold">Powered by:</small> <br>
                        </b-col>
                        <b-col cols="12 text-center">
                            <img :src="require('@/assets/izidok.png')" class="print-logo" width="100" alt="izidok">
                            <br />
                            <br />
                            <br />
                            ******************
                            <br />
                            Semoga Lekas Sembuh dan Sehat Selalu
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import startCase from "lodash/startCase"
import moment from 'moment'
moment.locale('id')
export default {
    data() {
        return {
            isBpjs: false,
            layananNormal: [],
            obatBpjs: [],
            tindakanBpjs: [],
        }
    },
    props: ['dataStruk', 'details', 'klinik', 'isDpm'],
    watch: {
        dataStruk: {
            deep: true,
            handler(val) {
                this.isBpjs = val.kategori == 'BPJS' ? true : false;
                this.getLayananType();
            }
        }
    },
    methods: {
        getLayananType() {
            this.layananNormal = []
            this.obatBpjs = []
            this.tindakanBpjs = []

            let rawDataLength = this.details.length;

            let data = this.details;
            let calculateTarif = this.details.slice(-3);

            data.forEach((item) => {
                // set default to 0 if null attribute
                item.subtotal_tarif = item.subtotal_tarif || 0,
                    item.subtotal_tarif_net = item.subtotal_tarif_net || 0,
                    item.tarif = item.tarif || 0

                if (item.from_bpjs == 0) {
                    this.layananNormal.push(item);
                } else if (item.from_bpjs == 1 && item.bpjs_sk_type == 0) {
                    this.tindakanBpjs.push(item);
                } else if (item.from_bpjs == 1 && item.bpjs_sk_type == 1) {
                    this.obatBpjs.push(item);
                }
            })

            this.layananNormal = [
                ...this.layananNormal,
                // ...calculateTarif
            ];
        },
        fields() {
            return [
                { key: 'layanan', label: "Layanan/Obat/Bahan Habis Pakai" },
                { key: "quantity", label: "QTY" },
                { key: "tarif", label: "Harga" },
                { key: "jenis_potongan", label: "Diskon" },
                { key: "potongan", label: "Nilai Diskon" },
                { key: "subtotal_tarif_net", label: "Sub Total (Rp)" },
            ]
        },
        cekNilaiDiskon(val) {
            let cek = true
            if (val == 'Total' || val == 'Diskon Total' || val == 'Total Nett') cek = false
            return cek
        },
        labelStartCase(val) {
            return startCase(val)
        },
        calculateTotal(data) {
            let total = 0;

            if (data.detail) {
                if (data.kategori == 'BPJS') {
                    data.detail.forEach((d) => {
                        if (d.from_bpjs == 0) {
                            total += +d.subtotal_tarif_net;
                        }
                    });
                } else {
                    data.detail.forEach((d) => {
                        total += +d.subtotal_tarif_net;
                    });
                }
                return `Rp${parseFloat(total).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")},-`;
            }
        },
        labelMetodePembayaran(data) {
            if (this.isBpjs) {
                const checkAllBPJS = data.detail.filter((d) => d.from_bpjs == 0);
                if (checkAllBPJS.length > 0) {
                    if (data.nama_bank && data.nama_rekening) {
                        return `${data.jenis_pembayaran} (${data.nama_bank.toUpperCase()}-${data.nama_rekening})`;
                    } else {
                        return data.jenis_pembayaran;
                    }
                } else {
                    return 'BPJS';
                }
            } else {
                if (data.nama_bank && data.nama_rekening) {
                    return `${data.jenis_pembayaran} (${data.nama_bank}-${data.nama_rekening})`;
                } else {
                    return data.jenis_pembayaran;
                }
            }
        },
    },
    computed: {
        tanggalCetak() {
            let tglCetak = "";
            if (this.dataStruk.date_now) {
                let datenow = this.dataStruk.date_now.split(",");
                let kota = this.dataStruk.klinik.kota_detail.nama;
                kota = kota.includes("Kota") ? kota.replace("Kota", "") : kota.replace("Kabupaten", "");
                tglCetak = kota + "," + datenow[1];
            }
            return tglCetak;
        }
    },
    filters: {
        formatDate(dateString) {
            return moment(dateString).format('DD/MMM/YYYY');
        },
        formatTime(timeStirng) {
            return moment(timeStirng).format('HH:mm');
        }
    },
}
</script>
<style lang="scss" scoped>
.color-gray-text {
    color: #848484
}

.pembayaran-status {
    position: absolute;
    top: 62%;
    left: 30%;
}

.struk-pembayaran {
    zoom: 90%;
}

.img-logo {
    height: 100px;
    border-radius: 10px;
}

.center-set {
    left: 25%;
}

.bordering {
    border: 1px solid #b1acac;
    width: 100%;
}

.f12 {
    font-size: 12px;
}

.send-top {
    top: -18px;
}
</style>
  
<style lang="scss">
.table {
    &.table-pembayaran-struk {
        thead {
            th {
                background-color: #4896e8 !important;
                color: #ffffff !important;
                text-transform: none;
            }
        }
    }
}

.modal-backdrop {
    opacity: 0.5 !important;
}

@page {
    size: auto;
    margin: 0;
}

@media print {
    body {
        background-color: transparent !important;
    }

    div.app-main {
        background-color: transparent !important;
    }

    div.app-content {
        background-color: transparent !important;
    }

    div.app-header {
        display: none !important;
    }

    div.app-sidebar {
        display: none !important;
    }

    div.app-footer {
        display: none !important;
    }

    div.app-content {
        margin: 0;
        padding-top: 1rem !important;
    }

    .pembayaran-status {
        position: absolute;
        top: 52% !important;
        left: 20% !important;
    }

    .table {
        &.table-pembayaran-struk {
            thead {
                th {
                    background-color: #4896e8 !important;
                    -webkit-print-color-adjust: exact;
                }
            }
        }
    }

    .center-set {
        left: -50px !important;
    }

    .card-box {
        border-width: 0 !important;
    }

    .center-set.col {
        padding: 0 !important;
    }

    .card {
        box-shadow: none !important;
    }

    * {
        font-family: 'Courier New', Courier, monospace;
        font-size: 12px;
        line-height: 12px;
    }

    .img-logo {
        height: 100px;
        border-radius: 10px;
    }

    .f12 {
        font-size: 12px;
    }

    .pr-0 {
        padding-right: 0 !important;
    }

    .pl-0 {
        padding-left: 0 !important;
    }

    .w1 {
        -moz-box-flex: 0 !important;
        flex: 0 0 9% !important;
        max-width: 9% !important;
    }

    .w5 {
        -moz-box-flex: 0 !important;
        flex: 0 0 50% !important;
        max-width: 50% !important;
    }

    .w6 {
        -moz-box-flex: 0 !important;
        flex: 0 0 41% !important;
        max-width: 41% !important;
    }
}
</style>